import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';

import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

import {CoreConfigService} from '@core/services/config.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../../../core/service';
import {RegisterRequest} from '../../../../core/requests/RegisterRequest';

@Component({
  selector: 'app-full-register',
  templateUrl: './full-register.component.html',
  styleUrls: ['./full-register.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FullRegisterComponent implements OnInit, OnDestroy {
  // Public
  public coreConfig: any;
  public passwordTextType: boolean = false;
  public registerForm: FormGroup;
  public submitted = false;
  public token: string;

  // Private
  private _unsubscribeAll: Subject<any>;
  public logo: string = null;

  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private _route: ActivatedRoute,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    this.token = this._route.snapshot.params.registerToken || '';
    this.registerForm = new FormGroup({
      password: new FormControl('', [Validators.required]),
      confirmPassword: new FormControl('', [Validators.required])
    });
    this._unsubscribeAll = new Subject();
    if (this.authenticationService.currentUserCompanyInfoValue) {
      this.logo = this.authenticationService.currentUserCompanyInfoValue.pictureUrl;
    }
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  /**
     * Toggle password
     */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  /**
     * On Submit
     */
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    const params: RegisterRequest = {
      password: this.f.password.value,
      confirmPassword: this.f.confirmPassword.value,
      activationToken: this.token
    };
    this.authenticationService.register(params)
      .subscribe(
        data => {
          this.onRegisterSuccess(data);
        },
        error => {
          this.onRegisterFail(error);
        });
  }

  public onRegisterSuccess(data: any) {
    // redirect to login
    setTimeout(() => {
      this._router.navigate(['/' + this.route.snapshot.params['subdomain'] + '/']);
    }, 100);
  }

  public onRegisterFail(error: HttpErrorResponse) {
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
     * On init
     */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  /**
     * On destroy
     */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }
}
